import { PregledSihtaricaInterface } from "./PregledSihtarica.resources";

export const PregledSihtaricaResourceEN: PregledSihtaricaInterface = {
  title: "Timesheet review",
  accessDenied:
    "You do not have access to timesheet review. This page is only available to managers and chiefs.",
  notLockedYet:
    "No approved entries for this period. PDF and review show only entries approved by a manager.",
  branch: "Branch",
  branchPlaceholder: "Select branch",
  startDate: "Start date",
  endDate: "End date",
  periodLabel: "Period (month)",
  statusOpen: "No approved entries",
  statusLocked: "Has approved entries",
  viewByWorker: "By workers",
  viewByDay: "By days",
  empty: "No records for the selected period.",
  totalHours: "Total",
  colDate: "Date",
  colWorker: "Worker",
  colType: "Type",
  colIn: "Clock in",
  colOut: "Clock out",
  colHours: "Hours",
  colNote: "Note",
  unapprove: "Unapprove",
  unapproveOk: "Approval has been revoked.",
  delete: "Delete",
  deleteConfirm: "Are you sure you want to delete this entry?",
  deleteOk: "Entry deleted.",
  cancel: "Cancel",
  actionError: "Action failed.",
  pdf: {
    button: "Download PDF",
    document: {
      name: "Full name",
      title: "Working time record",
      odabraniPeriod: "Selected period",
      ukupnoVrijeme: "Total hours",
      potpisFooter: "Signature",
      upisaoFooter: "Approved by",
      entryType: "Entry type",
      napomena: "Note",
      pocetak: "Start",
      pocetakPauze: "Break start",
      potpisano: "Signed",
      zavrsetak: "End",
      zavrsetakPauze: "Break end",
      tipovi: {
        DEZURA: "Duty",
        ODSUSTVO: "Absence",
        PRIPRAVNOST: "On-call",
        RADNOVRIJEME: "Working time",
        RADUSMJENAMA: "Shift work",
        TERENSKIRAD: "Field work",
        BOLOVANJE: "Sick leave",
        SLOBODANDAN: "Day off",
      },
    },
  },
};
